import { RecordingBase, RewindRecording, WaveWithInsights } from 'types/recordings';
import { SurfHeight } from 'types/units';
import { WaveGraphBar } from './waveInsightData';
import { RewindStillMap } from './previewStills';

export enum RewindErrorType {
  NO_DATA = 'NO_DATA',
  NO_WAVES_TRACKED = 'NO_WAVES_TRACKED',
  GENERATING_INSIGHTS = 'GENERATING_INSIGHTS',
  VISIBILITY_BAD = 'VISIBILITY_BAD',
  VISIBILITY_GOOD_LOW_WAVES = 'VISIBILITY_GOOD_LOW_WAVES',
  VISIBILITY_BAD_LOW_WAVES = 'VISIBILITY_BAD_LOW_WAVES',
}

export interface RewindError {
  startDate: Date;
  endDate: Date;
  type: RewindErrorType;
}

export type BaseRewindPlaylistBlock = {
  bucketStart: Date;
  bucketEnd: Date;
  rewinds: RecordingBase[];
  associated?: { units: { waves: { height: SurfHeight } } };
  errors: RewindError[];
};

export type SmartRewindData = {
  waveGraphBars: WaveGraphBar[];
  hasInsights?: boolean;
};

export type ClipsData = {
  waves: WaveWithInsights[];
  hasInsights?: boolean;
};

export interface SmartRewindPlaylistBlock extends BaseRewindPlaylistBlock {
  waveGraphBars: WaveGraphBar[];
  hasInsights?: boolean;
  rewinds: RewindRecording[];
}

export interface ClipsPlaylistBlock extends BaseRewindPlaylistBlock {
  waves: WaveWithInsights[];
  hasInsights?: boolean;
  rewinds: RewindRecording[];
  stills?: RewindStillMap;
}

export interface TrimmingClipPlaylistBlock extends BaseRewindPlaylistBlock {
  trimmedStartTime: Date;
  trimmedEndTime: Date;
}

type EndTimeOfPlaylist = string;

export type ClipsPlaylist = Map<EndTimeOfPlaylist, ClipsPlaylistBlock>;
export type RewindPlaylists = Map<EndTimeOfPlaylist, SmartRewindPlaylistBlock>;
